// extracted by mini-css-extract-plugin
module.exports = {"heading":"DummyPage_heading__8_NFj","list":"DummyPage_list__3cPjA","item":"DummyPage_item__3Nism"};